import { Box, Button, Container, Paper, Typography } from "@mui/material";
import React from "react";
import DataTable from "./DataTable";
import CustomerContext from "./context";
import { useCustomersManager } from "./useCustomers";
import { useNavigate } from "react-router-dom";

const Customers = () => {
  const navigate = useNavigate();
  return (
    <Paper sx={{ p: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5">Clientes</Typography>

        <Button onClick={() => navigate("./create")} variant="contained">
          Registrar
        </Button>
      </Box>
      <DataTable />
    </Paper>
  );
};

const Index = () => {
  return (
    <CustomerContext.Provider value={useCustomersManager()}>
      <Customers />
    </CustomerContext.Provider>
  );
};

export default React.memo(Index);
